import { AlertTriangle, BarChart3, Package, QrCode, Settings, Users, X } from 'lucide-react';
import React from 'react';
import { NavLink } from 'react-router-dom';
import aegisLogo from '../../assets/aegis-verify-logo.jpeg';

const ADMIN_MENU = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: BarChart3 },
  { to: '/admin/users', label: 'Users Management', icon: Users },
  { to: '/admin/products', label: 'Products', icon: Package },
  { to: '/admin/scans', label: 'Scan History', icon: QrCode },
  { to: '/admin/failed-scans', label: 'Failed Scans', icon: AlertTriangle },
  { to: '/admin/settings', label: 'Settings', icon: Settings },
];

export const Sidebar = ({ sidebarOpen, onClose }) => (
  <div
    className={`fixed inset-y-0 left-0 z-50 w-64 bg-gray-900 border-r border-gray-800 transform ${
      sidebarOpen ? 'translate-x-0' : '-translate-x-full'
    } transition-transform duration-200 ease-out lg:translate-x-0 lg:static lg:inset-0`}
  >
    <div className="flex items-center justify-between h-14 px-4 border-b border-gray-800">
      <div className="flex items-center space-x-2.5">
        <img src={aegisLogo} alt="Aegis Verify" className="h-8 w-8 rounded-md object-cover" />
        <div>
          <span className="text-sm font-semibold text-white leading-tight block">Aegis Verify</span>
          <p className="text-[11px] text-gray-500 leading-tight">Verification Portal</p>
        </div>
      </div>
      <button
        onClick={onClose}
        className="lg:hidden p-1.5 rounded-md hover:bg-gray-800 text-gray-400 hover:text-white transition-colors"
      >
        <X className="h-5 w-5" />
      </button>
    </div>
    <nav className="mt-3 px-3 space-y-0.5">
      {ADMIN_MENU.map((item) => {
        const IconComponent = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={onClose}
            className={({ isActive }) =>
              `flex items-center px-3 py-2 rounded-lg text-sm transition-colors ${
                isActive
                  ? 'bg-indigo-600 text-white font-medium'
                  : 'text-gray-400 hover:bg-gray-800 hover:text-gray-200'
              }`
            }
          >
            <IconComponent className="h-[18px] w-[18px] mr-3 shrink-0" />
            {item.label}
          </NavLink>
        );
      })}
    </nav>
  </div>
);
